import React from "react";
import { IGif } from "services/types";
import { GalleryGif } from "./GalleryGif";
import { useGalleryQuery } from "queries";

interface IGalleryGifContainerProps {
  galleryId: string;
  initialGif: IGif;
  setCurrentGalleryGif: React.Dispatch<React.SetStateAction<IGif | null>>;
  onLike: () => void;
  viewMetricQuery: (gif: IGif) => void;
}

export const GalleryGifContainer: React.FC<IGalleryGifContainerProps> = ({
  galleryId,
  ...props
}) => {
  const { data } = useGalleryQuery(galleryId);

  if (!data) {
    return null;
  }

  return (
    <GalleryGif gallery={data.gifs} {...props} />
  );
};

